<div class="debug-itrent-employee">
  <h2>Raw employee data</h2>
  <div class="row pb-2">
    <div class="col-2">
      <button type="button" class="btn btn-primary" (click)="getRawResponseForEmployee()">Get employee</button>
    </div>
    <div class="col">
      <input type="text" class="form-control" [(ngModel)]="employeeId" placeholder="Enter employee id">
    </div>
  </div>
  <div class="row pb-3">
    <div class="col">
      <textarea class="form-control" rows="5" [(ngModel)]="rawEmployeeResponse"></textarea>
    </div>
  </div>
</div>
